import { get } from 'lodash';
import { connect } from 'react-redux';

import CartLineItem from 'components/CartLineItem';
import CartLineItemModel from 'models/CartLineItem';
import * as actions from 'state/actions/ajax-cart';
import { ADD_TO_CART_ANALYTICS_ORIGINS } from 'state/constants';
import Settings from 'utils/Settings';

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps;
  const data = get(state, ['ajaxCart', 'data', 'entities', 'item', id]);

  const item = new CartLineItemModel(data);

  const isBeingAdded = !!get(state, ['ajaxCart', 'itemsBeingAdded', id]);
  const isBeingUpdated = !!get(state, ['ajaxCart', 'itemsBeingUpdated', id]);
  const isBeingRemoved = !!get(state, ['ajaxCart', 'itemsBeingRemoved', id]);
  const showShoprunner = Settings.shoprunnerEnabled && item.isShoprunnerEligible;
  const enableDiscountPriceColor = Settings.enableDiscountPriceColor;
  const isFinalSale = Settings.finalSaleMessagingEnabled && item.isFinalSale;

  return {
    item,
    isBeingUpdated: isBeingUpdated || isBeingAdded,
    isBeingRemoved,
    showShoprunner,
    enableDiscountPriceColor,
    isFinalSale,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { id } = ownProps;

  return {
    add: quantity =>
      dispatch(
        actions.addLineItems(
          { [id]: quantity },
          { origination: ADD_TO_CART_ANALYTICS_ORIGINS.CART }
        )
      ),
    update: quantity => dispatch(actions.updateLineItem(id, quantity)),
    remove: () => dispatch(actions.removeLineItem(id)),
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  const { item } = stateProps;
  const { update, add } = dispatchProps;

  // Shopify APIs will throw an error when adding an item that is out of stock (as it should),
  // but will not throw an error if you increase the quantity of an item that is out stock.
  // This is the reason why incerement is not using the update function, and instead uses add

  return {
    ...stateProps,
    ...dispatchProps,
    increment: () => add(1),
    decrement: () => update(item.quantity - 1),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CartLineItem);
